// extracted by mini-css-extract-plugin
module.exports = {"root":"templates-layout-module--root--E63FK"};